import { Divider } from '@mantine/core'
import dividerClassNames from './styles.module.css'

export default Divider.extend({
    // Drop Mantine's default props so that our styles win
    defaultProps: { color: undefined },
    classNames: dividerClassNames,
})
